define("shared/components/shared/social-identity/info", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@handleClose}} @focusTrap={{true}} as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header @title={{t "shared_phrases.social_sets.info.header"}} />
      <modal.card-body class="u--p__t__0">
        <p class="u--p__b__sm">
          {{t "shared_phrases.social_sets.info.description"}}
        </p>
  
        <Shared::SocialIdentity />
  
        {{#if @showDetails}}
          <br />
          <p class="u--text--md u--text--bold u--m__t__md">
            {{t "shared_phrases.social_sets.info.more.title"}}
          </p>
  
          <p>{{t "shared_phrases.social_sets.info.more.num_included"}}</p>
          <p>{{t "shared_phrases.social_sets.info.more.effective"}}</p>
          <p>{{html-safe (t "shared_phrases.social_sets.info.more.note")}}</p>
        {{/if}}
      </modal.card-body>
  
      <modal.card-footer>
        <div class="o--btnBar u--float--right">
          <Shared::Ui::Button @onClick={{@handleClose}} @text={{t "shared_words.close"}} @variant="outline" />
        </div>
      </modal.card-footer>
  
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "Mnjz1Wil",
    "block": "[[[8,[39,0],null,[[\"@close\",\"@focusTrap\"],[[30,1],true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],null,[[\"@title\"],[[28,[37,1],[\"shared_phrases.social_sets.info.header\"],null]]],null],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[14,0,\"u--p__b__sm\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"shared_phrases.social_sets.info.description\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[8,[39,2],null,null,null],[1,\"\\n\\n\"],[41,[30,3],[[[1,\"        \"],[10,\"br\"],[12],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--md u--text--bold u--m__t__md\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"shared_phrases.social_sets.info.more.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[10,2],[12],[1,[28,[35,1],[\"shared_phrases.social_sets.info.more.num_included\"],null]],[13],[1,\"\\n        \"],[10,2],[12],[1,[28,[35,1],[\"shared_phrases.social_sets.info.more.effective\"],null]],[13],[1,\"\\n        \"],[10,2],[12],[1,[28,[35,4],[[28,[37,1],[\"shared_phrases.social_sets.info.more.note\"],null]],null]],[13],[1,\"\\n\"]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"o--btnBar u--float--right\"],[12],[1,\"\\n        \"],[8,[39,5],null,[[\"@onClick\",\"@text\",\"@variant\"],[[30,1],[28,[37,1],[\"shared_words.close\"],null],\"outline\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@handleClose\",\"modal\",\"@showDetails\"],false,[\"shared/modal\",\"t\",\"shared/social-identity\",\"if\",\"html-safe\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/social-identity/info.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});